<template>
    <div id="main" class="is-flex">
        <div class="page">
            <div class="vertical-flow">
                <h1 class="title">
                    {{ $t('atendimentos-agricola') }}:
                    {{
                        atendimentoagricola.cliente
                            ? atendimentoagricola.cliente.rsocial
                            : $t('sem-cliente')
                    }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t('vendas') }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{ $t('crm') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push({ name: 'venda-atendimentos-agricola' })">{{
                                $t('atendimentos-agricola')
                            }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{
                                atendimentoagricola.cliente
                                    ? atendimentoagricola.cliente.rsocial
                                    : $t('sem-cliente')
                            }}</a>
                        </li>
                    </ul>
                </nav>
                <!-- ABAS -->
                <div class="columns">
                    <div class="column is-9">
                        <ul class="nav nav-tabs" v-if="id">
                            <!-- Abas expandidas manualmente ao invés de usar v-for para poder controlar
                        as abas que podem ser escondidas mais facilmente (RTR e Fotos RTR) -->
                            <li
                                :class="{ active: abaSelecionada == 0 }"
                                @click="navigateToIndex(0)"
                            >
                                <a data-toggle="tab">{{ $t('geral') }}</a>
                            </li>
                            <li
                                :class="{ active: abaSelecionada == 1 }"
                                @click="navigateToIndex(1)"
                            >
                                <a data-toggle="tab">{{ $t('fotos') }}</a>
                            </li>
                            <li
                                :class="{ active: abaSelecionada == 2 }"
                                @click="navigateToIndex(2)"
                                v-if="habilitaAbasRTR"
                            >
                                <a data-toggle="tab">{{ $t('agro-visita') }}</a>
                            </li>
                            <li
                                :class="{ active: abaSelecionada == 3 }"
                                @click="navigateToIndex(3)"
                                v-if="habilitaAbasRTR"
                            >
                                <a data-toggle="tab">{{ $t('fotos-agro-visita') }}</a>
                            </li>
                        </ul>
                        <!-- end abas -->
                    </div>
                    <!-- BOTÃ•ES DA EXPORTAÇÃO -->
                    <div
                        v-if="exportacaoTipo && atendimentoagricola && permissao.export"
                        class="column is-3"
                    >
                        <div class="exportIcons" style="justify-content: flex-end">
                            <div
                                v-if="exportacaoTipo.exportaemail == 1"
                                class="export-icon"
                                @click="saveExportacao('email')"
                            >
                                <b-icon
                                    icon="email-outline"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-email')"
                                />
                            </div>
                            <div
                                v-if="exportacaoTipo.exportawhatsapp == 1"
                                class="export-icon"
                                @click="saveExportacao('whatsapp')"
                            >
                                <b-icon
                                    icon="whatsapp"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-whatsapp')"
                                />
                            </div>
                            <div
                                v-if="exportacaoTipo.exportapdf == 1"
                                class="export-icon"
                                @click="saveExportacao('pdf')"
                            >
                                <b-icon
                                    icon="file-pdf"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-pdf')"
                                />
                            </div>
                            <div
                                v-if="exportacaoTipo.exportaexcel == 1"
                                class="export-icon"
                                @click="saveExportacao('excel')"
                            >
                                <b-icon
                                    icon="file-excel"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-excel')"
                                />
                            </div>
                            <div
                                v-if="exportacaoTipo.exportacsv == 1"
                                class="export-icon"
                                @click="saveExportacao('csv')"
                            >
                                <b-icon
                                    icon="file"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-csv')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ABA GERAL -->
                <div class="aba-geral" v-if="abas[abaSelecionada] == 'geral'">
                    <div class="columns">
                        <div class="column is-half">
                            <vss-select
                                ref="empresaSelect"
                                title="empresa"
                                v-model="atendimentoagricola.empresa"
                                :options="empresas"
                                :disabled="!isNull($route.params.id)"
                                label="nome"
                                @input="updateValueEmpresa"
                                required
                                :invalid="verify(atendimentoagricola.empresa)"
                                :loading="empresasLoading"
                                @search="carregarEmpresas"
                            />
                        </div>
                        <div class="column is-half">
                            <v-input
                                title="situacao"
                                :value="
                                    atendimentoagricola.situacao > 0
                                        ? $t('finalizado')
                                        : $t('em-preenchimento')
                                "
                                :disabled="alwaysTrue"
                                readonly
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div
                            class="column"
                            :class="{
                                'is-half': hasPropriedade,
                                'is-full': !hasPropriedade,
                            }"
                        >
                            <vss-select
                                ref="clienteSelect"
                                :value="clienteSelecionado"
                                label="rsocial"
                                title="cliente"
                                :options="clientes"
                                :disabled="situacao > 0 || isSaving || saved || disabledByEmpresa"
                                :invalidWhenDisabled="true"
                                @search="carregarClientes"
                                @input="updateValueCliente"
                                :loading="clientesLoading"
                                searchable
                                clearable
                            />
                        </div>
                        <div
                            class="column is-half"
                            v-if="
                                hasPropriedade && detalhe.PROPRIEDADE && !detalhe.PROPRIEDADE.oculta
                            "
                        >
                            <vss-select
                                ref="propriedadeSelect"
                                v-model="atendimentoagricola.propriedade"
                                label="nome"
                                :title="
                                    detalhe.PROPRIEDADE
                                        ? detalhe.PROPRIEDADE.label || 'propriedade'
                                        : 'propriedade'
                                "
                                :options="propriedades"
                                :disabled="
                                    situacao > 0 ||
                                    isSaving ||
                                    saved ||
                                    disabledByEmpresa ||
                                    disabledByCliente
                                "
                                :invalid="
                                    checkInvalid('PROPRIEDADE', !atendimentoagricola.propriedade)
                                "
                                @search="carregarPropriedades"
                                @input="changePropriedade"
                                searchable
                                :required="detalhe.PROPRIEDADE.obrigainclusao"
                                :loading="propriedadesLoading"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div v-if="!detalhe.MOTIVOATENDIMENTO.oculta" class="column is-6">
                            <vss-select
                                ref="motivoSelect"
                                label="descricao"
                                :value="atendimentoagricola.motivoAtendimento"
                                :title="
                                    detalhe.MOTIVOATENDIMENTO
                                        ? detalhe.MOTIVOATENDIMENTO.label || 'motivo'
                                        : 'motivo'
                                "
                                :options="motivos"
                                :disabled="situacao > 0 || isSaving || saved"
                                :invalid="
                                    checkInvalid(
                                        'MOTIVOATENDIMENTO',
                                        atendimentoagricola.motivoAtendimento
                                    )
                                "
                                @search="carregarMotivos"
                                @input="checkValidacoesMotivo"
                                searchable
                                :required="detalhe.MOTIVOATENDIMENTO.obrigainclusao"
                                :loading="motivosLoading"
                            />
                        </div>
                        <div class="column is-3" v-if="detalhe.CONTATO && !detalhe.CONTATO.oculta">
                            <!-- Contato é validado pelo motivo -->
                            <v-input
                                ref="contatoInput"
                                v-model.trim="atendimentoagricola.contato"
                                :title="
                                    detalhe.CONTATO ? detalhe.CONTATO.label || 'contato' : 'contato'
                                "
                                :maxlength="
                                    detalhe.CONTATO ? detalhe.CONTATO.maxlength || 255 : 255
                                "
                                :invalid="
                                    motivo.obrigaContato ? !atendimentoagricola.contato : false
                                "
                                :readonly="situacao > 0"
                                :disabled="isSaving || saved"
                                :required="detalhe.CONTATO.obrigainclusao"
                            />
                        </div>
                        <div
                            class="column is-3"
                            v-if="detalhe.DATAATENDIMENTO && !detalhe.DATAATENDIMENTO.oculta"
                            @focus="dataFocusedOut = true"
                            @blur="dataFocusedOut = false"
                        >
                            <verified-date-picker
                                ref="dataAtendInput"
                                v-model="dataAtendimento"
                                :title="
                                    !isNull(detalhe.DATAATENDIMENTO.label)
                                        ? detalhe.DATAATENDIMENTO.label
                                        : 'data'
                                "
                                :disableMLtitle="!isNull(detalhe.DATAATENDIMENTO.label)"
                                :inForm="true"
                                :disabled="isSaving || saved"
                                :years-range="[1, 1]"
                                :subtractDateDays="1"
                                :addDateYears="1"
                                @input="updateDataAtendimento"
                                :required="detalhe.DATAATENDIMENTO.obrigainclusao"
                            />
                            <span
                                class="validation"
                                v-text="$t('msg-campo-obrigatorio')"
                                v-if="dataFocusedOut && dataInvalid"
                            />
                        </div>
                    </div>
                    <div class="columns obs">
                        <div
                            class="column obs is-flex"
                            v-if="detalhe.OBSERVACAO && !detalhe.OBSERVACAO.oculta"
                        >
                            <v-textarea
                                ref="obsTextArea"
                                class="obs-ta"
                                v-model.trim="atendimentoagricola.observacao"
                                :title="
                                    detalhe.OBSERVACAO
                                        ? detalhe.OBSERVACAO.label || 'observacao'
                                        : 'observacao'
                                "
                                :maxlength="
                                    detalhe.OBSERVACAO ? detalhe.OBSERVACAO.maxlength || 500 : 500
                                "
                                :invalid="
                                    motivo.obrigaObservacao
                                        ? !atendimentoagricola.observacao
                                        : false
                                "
                                :readonly="situacao > 0"
                                :disabled="isSaving || saved"
                                disableMLtitle
                                :required="detalhe.OBSERVACAO.obrigainclusao"
                            />
                        </div>
                    </div>
                </div>
                <!-- end aba geral -->
                <!-- ABA FOTOS -->
                <div class="aba-fotos registry-wrapper" v-if="abas[abaSelecionada] == 'fotos'">
                    <div class="columns is-multiline">
                        <div
                            class="column is-full photo-warning py-1"
                            v-if="
                                motivo.minimoFotos &&
                                situacao == 0 &&
                                ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                            "
                        >
                            {{ $t('msg-n-fotos-atendimento', { n: motivo.minimoFotos }) }}
                        </div>
                        <div
                            class="column is-full is-flex"
                            v-if="
                                situacao == 0 &&
                                detalhe.IMAGENS &&
                                !detalhe.IMAGENS.oculta &&
                                ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                            "
                        >
                            <file-picker
                                ref="filePicker"
                                class="upload-picker is-100"
                                v-model="file"
                                accepted="image/*"
                                :allowedtypes="['image/jpeg', 'image/png']"
                                :disabled="isUploading || fotosLoading || saved"
                                @alert="showMessage"
                                return-raw-file
                            />
                            <button
                                class="btn save-btn ml-4 px-4 py-2 is-flex is-flex-centered"
                                @click="addAnexo"
                                :disabled="isUploading || !file || fotosLoading || saved"
                            >
                                {{ $t('adicionar') }}
                                <button-loader :isSaving="isUploading" />
                            </button>
                        </div>
                        <div
                            class="column"
                            v-if="situacao == 0 && detalhe.IMAGENS && !detalhe.IMAGENS.oculta"
                        >
                            <v-input
                                v-model="obsFoto"
                                title="observacao"
                                :maxlength="255"
                                :disabled="isUploading || fotosLoading || saved"
                            />
                        </div>
                    </div>
                    <container-loader
                        class="fotos-loader"
                        v-if="fotosLoading && !$store.getters.isLoading"
                    />
                    <empty-table-message v-if="fotos && !fotos.length" />
                    <b-table
                        v-else
                        ref="fotosTable"
                        class="data-table"
                        :data="fotos"
                        @sort="sortFotos"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(u, i) in fieldsFoto"
                            class="td-center"
                            :key="i"
                            :field="u.key"
                            :label="$t(u.label)"
                            :width="u.width"
                            :sortable="u.sortable"
                            :centered="u.centered"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'datahora'">
                                {{ props.row[u.key] | moment('L LT') }}
                            </div>
                            <div v-else-if="u.key == 'observacao'">
                                {{ props.row[u.key] }}
                            </div>
                            <div v-else-if="u.key == 'caminho'">
                                <img
                                    :src="props.row[u.key]"
                                    :alt="props.row['observacao']"
                                    class="clickable"
                                    @click="openModalFotos(props.row[u.key])"
                                />
                            </div>
                            <a
                                v-else
                                :href="props.row['caminho']"
                                target="_blank"
                                class="export-icon"
                            >
                                <b-icon
                                    icon="file-download"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-imagem-download')"
                                />
                            </a>
                        </b-table-column>
                    </b-table>
                    <!-- PAGINAÇÃO -->
                    <b-pagination
                        order="is-centered"
                        :total="fotosPag.totalRows"
                        :current.sync="fotosPag.currentPage"
                        :per-page="fotosPag.size"
                        @change="carregarAnexos"
                    />
                </div>
                <!-- end aba fotos -->
                <!-- ABA RTR -->
                <div class="aba-agro-visita" v-if="abas[abaSelecionada] == 'rtr'">
                    <!-- MOSTRAR ÁREA E TALHÃO SE POSSUIR MODULOPDA DE PROPRIEDADE -->
                    <div class="columns" v-if="hasPropriedade">
                        <div
                            class="column is-6"
                            v-if="detalhe.RTR_AREA && !detalhe.RTR_AREA.oculta"
                        >
                            <vss-select
                                ref="areaSelect"
                                v-model="atendimentoagricola.rtr.area"
                                label="descricao"
                                :options="areas"
                                :title="
                                    detalhe.RTR_AREA ? detalhe.RTR_AREA.label || 'area' : 'area'
                                "
                                :loading="areasLoading"
                                :placeholder="
                                    !atendimentoagricola.propriedade
                                        ? 'msg-selecione-propriedade'
                                        : null
                                "
                                :disabled="
                                    !atendimentoagricola.propriedade ||
                                    isSaving ||
                                    situacaoRtr > 0 ||
                                    savedRtr
                                "
                                :invalid="checkInvalid('RTR_AREA', atendimentoagricola.rtr.area)"
                                @search="carregarAreas"
                                @input="changeArea"
                                searchable
                            />
                        </div>
                        <div
                            class="column is-6"
                            v-if="detalhe.RTR_TALHAO && !detalhe.RTR_TALHAO.oculta"
                        >
                            <vss-select
                                ref="talhaoSelect"
                                v-model="atendimentoagricola.rtr.talhao"
                                label="descricao"
                                :options="talhoes"
                                :title="
                                    detalhe.RTR_TALHAO
                                        ? detalhe.RTR_TALHAO.label || 'talhao'
                                        : 'talhao'
                                "
                                :loading="talhoesLoading"
                                :placeholder="
                                    !atendimentoagricola.rtr.area ? 'msg-selecione-area' : null
                                "
                                :disabled="
                                    !atendimentoagricola.rtr.area ||
                                    isSaving ||
                                    situacaoRtr > 0 ||
                                    savedRtr
                                "
                                :invalid="
                                    checkInvalid('RTR_TALHAO', atendimentoagricola.rtr.talhao)
                                "
                                @search="carregarTalhoes"
                                searchable
                            />
                        </div>
                    </div>
                    <!-- ASSUNTO E TIPO DO RTR -->
                    <div class="columns is-multiline">
                        <div
                            class="column is-6"
                            v-if="detalhe.RTR_ASSUNTO && !detalhe.RTR_ASSUNTO.oculta"
                        >
                            <vss-select
                                ref="assuntoSelect"
                                v-model="atendimentoagricola.rtr.assunto"
                                label="descricao"
                                :options="assuntos"
                                :title="
                                    detalhe.RTR_ASSUNTO
                                        ? detalhe.RTR_ASSUNTO.label || 'assunto-agro-visita'
                                        : 'assunto-agro-visita'
                                "
                                :loading="assuntosLoading"
                                :disabled="isSaving || situacaoRtr > 0 || savedRtr"
                                :invalid="
                                    checkInvalid('RTR_ASSUNTO', atendimentoagricola.rtr.assunto)
                                "
                                @search="carregarAssuntos"
                                searchable
                            />
                        </div>
                        <div
                            class="column is-6"
                            v-if="detalhe.RTR_TIPO && !detalhe.RTR_TIPO.oculta"
                        >
                            <vss-select
                                ref="tipoRtrSelect"
                                v-model="atendimentoagricola.rtr.tipo"
                                label="descricao"
                                :options="tipos"
                                :title="
                                    detalhe.RTR_TIPO
                                        ? detalhe.RTR_TIPO.label || 'tipo-agro-visita'
                                        : 'tipo-agro-visita'
                                "
                                :loading="tiposLoading"
                                :disabled="isSaving || situacaoRtr > 0 || savedRtr"
                                :invalid="checkInvalid('RTR_TIPO', atendimentoagricola.rtr.tipo)"
                                @search="carregarTipos"
                                searchable
                            />
                        </div>
                    </div>
                    <div class="columns is-multiline">
                        <div class="column is-6">
                            <v-input
                                title="situacao"
                                :value="
                                    atendimentoagricola.rtr.situacao > 0
                                        ? 'finalizado'
                                        : 'em-preenchimento'
                                "
                                :disabled="savedRtr"
                                readonly
                            />
                        </div>
                        <!-- @ 87166 - tramite 19 -->
                        <div
                            class="column is-half"
                            v-if="detalhe.RTR_DATA && !detalhe.RTR_DATA.oculta"
                        >
                            <verified-date-picker
                                ref="dataRtrInput"
                                v-model="dataRTR"
                                :title="
                                    detalhe.RTR_DATA
                                        ? detalhe.RTR_DATA.label || $t('data')
                                        : $t('data')
                                "
                                :disableMLtitle="!isNull(detalhe.DATAATENDIMENTO.label)"
                                :inForm="true"
                                :readonly="situacaoRtr > 0"
                                :disabled="isSaving || saved"
                                :invalid="
                                    checkInvalid('RTR_DATA', atendimentoagricola.rtr.datahora)
                                "
                                :years-range="[-20, 1]"
                                @input="updateDataRTR"
                            />
                        </div>
                    </div>
                    <div class="columns is-multiline">
                        <div
                            class="column is-one-third"
                            v-if="detalhe.RTR_CULTURA && !detalhe.RTR_CULTURA.oculta"
                        >
                            <vss-select
                                :title="detalhe.RTR_CULTURA
                                        ? detalhe.RTR_CULTURA.label || $t('cultura')
                                        : $t('cultura')"
                                disableMLtitle
                                ref="culturaSelect"
                                v-model="atendimentoagricola.rtr.cultura"
                                label="descricao"
                                :options="culturas"
                                :loading="culturasLoading"
                                :disabled="isSaving || situacaoRtr > 0 || savedRtr"
                                :invalid="
                                    checkInvalid('RTR_CULTURA', atendimentoagricola.rtr.cultura)
                                "
                                @search="carregarCulturas"
                                @input="updateCultura"
                                :required="detalhe.RTR_CULTURA.obrigainclusao"
                                searchable
                                tooltipLabel="msg-tooltip-cultura-selecionada"
                            />
                        </div>
                        <div
                            class="column is-one-third"
                            v-if="detalhe.RTR_CULTIVAR && !detalhe.RTR_CULTIVAR.oculta"
                        >
                            <vss-select
                                ref="cultivarSelect"
                                v-model="atendimentoagricola.rtr.cultivar"
                                label="descricao"
                                :options="cultivares"
                                :title="
                                    detalhe.RTR_CULTIVAR
                                        ? detalhe.RTR_CULTIVAR.label || 'cultivar'
                                        : 'cultivar'
                                "
                                :loading="cultivaresLoading"
                                :disabled="isSaving || situacaoRtr > 0 || savedRtr"
                                :invalid="
                                    checkInvalid('RTR_CULTIVAR', atendimentoagricola.rtr.cultivar)
                                "
                                @search="carregarCultivares"
                                :required="detalhe.RTR_CULTIVAR.obrigainclusao"
                                searchable
                            />
                        </div>
                        <!-- @87166 - utilizado mesmo modulo de fase do cultivo para fase fenologica -->
                        <div
                            class="column is-one-third"
                            v-if="detalhe.RTR_FASECULTIVO && !detalhe.RTR_FASECULTIVO.oculta"
                        >
                            <vss-select
                                ref="faseSelect"
                                v-model="fase"
                                label="descricao"
                                :options="fases"
                                :title="
                                    detalhe.RTR_FASECULTIVO
                                        ? detalhe.RTR_FASECULTIVO.label || 'agro-fasefenologica'
                                        : 'agro-fasefenologica'
                                "
                                :loading="fasesLoading"
                                :disabled="isSaving || situacaoRtr > 0 || savedRtr"
                                :invalid="checkInvalid('RTR_FASECULTIVO', fase)"
                                @search="carregarFases"
                                :required="detalhe.RTR_FASECULTIVO.obrigainclusao"
                                searchable
                            />
                        </div>
                    </div>
                    <!-- OBSERVAÇÃO GERAL -->
                    <div
                        class="obs is-flex"
                        v-if="detalhe.RTR_OBSERVACAOGERAL && !detalhe.RTR_OBSERVACAOGERAL.oculta"
                    >
                        <v-textarea
                            ref="obsGeralTextArea"
                            v-model="atendimentoagricola.rtr.observacaoGeral"
                            class="obs-ta"
                            :title="
                                detalhe.RTR_OBSERVACAOGERAL
                                    ? detalhe.RTR_OBSERVACAOGERAL.label || 'observacao'
                                    : 'observacao'
                            "
                            :maxlength="500"
                            :disabled="isSaving || savedRtr"
                            :readonly="situacaoRtr > 0"
                            :invalid="
                                checkInvalid(
                                    'RTR_OBSERVACAOGERAL',
                                    atendimentoagricola.rtr.observacaoGeral
                                )
                            "
                        />
                    </div>
                </div>
                <!-- end aba RTR -->
                <!-- ABA FOTOS RTR -->
                <div
                    class="aba-fotos-agro-visita registry-wrapper"
                    v-if="abas[abaSelecionada] == 'fotos-agro-visita'"
                >
                    <div
                        class="columns is-multiline"
                        v-if="situacao == 0 && detalhe.RTR_IMAGENS && !detalhe.RTR_IMAGENS.oculta"
                    >
                        <div
                            class="column is-full is-flex"
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        >
                            <file-picker
                                ref="filePickerRtr"
                                class="upload-picker is-100"
                                v-model="fileRtr"
                                accepted="image/*"
                                :allowedtypes="['image/jpeg', 'image/png']"
                                :disabled="isUploadingRtr || savedRtr"
                                @alert="showMessage"
                                return-raw-file
                            />
                            <button
                                class="btn save-btn ml-4 px-4"
                                @click="addAnexoRtr"
                                :disabled="isUploadingRtr || !fileRtr || savedRtr"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                        <div class="column">
                            <v-input
                                v-model="obsFotoRtr"
                                title="observacao"
                                :maxlength="255"
                                :disabled="savedRtr"
                            />
                        </div>
                    </div>
                    <container-loader v-if="fotosRtrLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="fotosRtr && !fotosRtr.length" />
                    <b-table
                        v-else
                        ref="fotosTable"
                        class="data-table"
                        :data="fotosRtr"
                        @sort="sortFotosRtr"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(u, i) in fieldsFoto"
                            class="td-center"
                            :key="i"
                            :field="u.key"
                            :label="$t(u.label)"
                            :width="u.width"
                            :sortable="u.sortable"
                            :centered="u.centered"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'datahora'">
                                {{ props.row[u.key] | moment('L LT') }}
                            </div>
                            <div v-else-if="u.key == 'observacao'">
                                {{ props.row[u.key] }}
                            </div>
                            <div v-else-if="u.key == 'caminho'">
                                <img
                                    :src="props.row[u.key]"
                                    :alt="props.row['observacao']"
                                    class="clickable"
                                    @click="openModalFotos(props.row[u.key])"
                                />
                            </div>
                            <a
                                v-else
                                :href="props.row['caminho']"
                                target="_blank"
                                class="export-icon"
                            >
                                <b-icon
                                    icon="file-download"
                                    size="is-medium"
                                    class="is-medium is-clickable"
                                    v-tippy 
                                    :title="$t('msg-tooltip-imagem-download')"
                                />
                            </a>
                        </b-table-column>
                    </b-table>
                    <!-- PAGINAÇÃO -->
                    <b-pagination
                        order="is-centered"
                        :total="fotosPagRtr.totalRows"
                        :current.sync="fotosPagRtr.currentPage"
                        :per-page="fotosPagRtr.size"
                        @change="carregarAnexosRtr"
                    />
                </div>
                <!-- end aba fotos RTR -->
                <!-- BOTÃ•ES -->
                <div class="form-buttons">
                    <!-- VOLTAR -->
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: 'venda-atendimentos-agricola' })"
                    >
                        {{ $t('voltar') }}
                    </button>
                    <!-- GERAR RTR -->
                    <button
                        class="delete-btn"
                        type="button"
                        @click="promptForRTR"
                        v-if="
                            id &&
                            situacao == 0 &&
                            motivo &&
                            motivo.habilitaRtr &&
                            atendimentoagricola &&
                            !atendimentoagricola.rtr &&
                            ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                        "
                        :disabled="isGenerating || $store.getters.isLoading || savedRtr"
                    >
                        {{ $t('gerar-agro-visita') }}
                    </button>
                    <!-- FINALIZAR -->
                    <button
                        class="save-btn"
                        type="button"
                        v-if="
                            situacao == 0 &&
                            id &&
                            abas[abaSelecionada] == 'geral' &&
                            ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                        "
                        @click="promptFinalize"
                        :disabled="isSaving || isGenerating || $store.getters.isLoading || saved"
                    >
                        {{ $t('finalizar') }}
                    </button>
                    <button
                        class="save-btn"
                        type="button"
                        v-if="
                            atendimentoagricola.rtr &&
                            atendimentoagricola.rtr.situacao == 0 &&
                            id &&
                            abas[abaSelecionada] == 'rtr' &&
                            ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                        "
                        @click="promptFinalizeRtr"
                        :disabled="isSaving || isGenerating || $store.getters.isLoading || savedRtr"
                    >
                        {{ $t('finalizar-agro-visita') }}
                    </button>
                    <!-- SALVAR -->
                    <button
                        v-if="
                            situacao == 0 &&
                            abas[abaSelecionada] == 'geral' &&
                            ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                        "
                        class="save-btn"
                        type="button"
                        @click="saveAtendimento()"
                        :disabled="isSaving || isGenerating || $store.getters.isLoading || saved"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                    <button
                        v-if="
                            situacaoRtr == 0 &&
                            abas[abaSelecionada] == 'rtr' &&
                            ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                        "
                        class="save-btn"
                        type="button"
                        @click="saveRTR()"
                        :disabled="isSaving || isGenerating || $store.getters.isLoading || savedRtr"
                    >
                        {{ $t('salvar-agro-visita') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
                <!-- end .form-buttons -->
            </div>
            <!-- end .vertical-flow -->
        </div>
        <!-- end .page -->

        <!-- Modal fotos do atendimento -->
        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="(carousels = []), (isShowModalFotos = false)"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel :pause-info="false" :animated="'fade'" :progress="true">
                                <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                                    <section>
                                        <div class="hero-body-img has-text-centered">
                                            <b-image
                                                :src="carousel.url"
                                                :responsive="true"
                                                class="image-control"
                                            />
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
    <!-- end #main -->
</template>
<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import AtendimentoAgricolaService from '@/services/AtendimentoAgricolaService';
import RelatorioTempoRealService from '@/services/RelatorioTempoRealService';
import VendasClienteService from '@/services/VendasClienteService';
import PropriedadeService from '@/services/agro/PropriedadeService';
import MotivoAtendimentoService from '@/services/MotivoAtendimentoAgricolaService';
import AreaService from '@/services/agro/AreaService';
import TalhaoService from '@/services/agro/TalhaoService';
import AssuntoRtrService from '@/services/agro/AssuntoRtrService';
import TipoRtrService from '@/services/agro/TipoRtrService';
import CultivarService from '@/services/agro/CultivarService';
import CulturaService from '@/services/agro/CulturaService';
import UsuarioWebService from '@/services/UsuarioWebService';
import FaseFenologicaService from '@/services/agro/FaseFenologicaService';
/********* exportação *********/
import ExportacaoTipoService from '@/services/ExportacaoTipoService';
import ExportacaoService from '@/services/ExportacaoService';
import ExportacaoLogService from '@/services/ExportacaoLogService';
import ExportacaoDadosService from '@/services/ExportacaoDadosService';
import EmailExportacaoService from '@/services/EmailExportacaoService';
import AtendimentoAgricolaValidation from '@/services/validations/AtendimentoAgricolaValidation';
import FilePicker from '@/components/shared/form/FilePicker';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada.
 * Usar AtendimentoManage -> Geral/Fotos ao inves.
 */
export default {
    components: {
        FilePicker,
        ContainerLoader,
    },
    data() {
        return {
            /********************************* SERVIÃ‡OS ******************************************/
            service: new AtendimentoAgricolaService(this.$http, this.$router),
            rtrService: new RelatorioTempoRealService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            proprService: new PropriedadeService(this.$http, this.$router),
            motivoService: new MotivoAtendimentoService(this.$http, this.$router),
            areaService: new AreaService(this.$http, this.$router),
            talhaoService: new TalhaoService(this.$http, this.$router),
            assuntoService: new AssuntoRtrService(this.$http, this.$router),
            tipoService: new TipoRtrService(this.$http, this.$router),
            cultivarService: new CultivarService(this.$http, this.$router),
            culturaService: new CulturaService(this.$http, this.$router),
            // faseService: new FaseCultivoService(this.$http, this.$router),
            faseService: new FaseFenologicaService(this.$http, this.$router),
            usuarioWebService: new UsuarioWebService(this.$http, this.$router),
            validation: new AtendimentoAgricolaValidation(
                this.$root.msgs,
                this.getModulo('ATENDIMENTOAGRICOLA')
            ),
            /********* exportação *********/
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            emailExportacaoService: new EmailExportacaoService(this.$http, this.$router),
            /********************************** DADOS ********************************************/
            id: this.$route.params.id,
            atendimentoagricola: {
                dataAtendimento: this.$moment().format('YYYY-MM-DD'),
                motivoAtendimento: null,
                cliente: null,
                propriedade: null,
                //Passa o usuarioerp porém no server é feito uma consulta com base no usuarioerp para pegar o idusuario da tabela usuario
                usuario: null,
                empresa: null,
            },
            //DEFINE O NOME DA TELA QUE Ã‰ USADA PARA AS EXPORTAÃ‡Ã•ES, DEVE SER O MESMO NOME DA ENUM DE EXPORTACAOTIPO! (IRÃ FAZER UM SELECT NA TABELA EXPORTACAOTIPO POR ESSE CAMPO)
            nomeTela: 'ATENDIMENTO',
            exportacaoTipo: null,
            exportacao: null,
            empresas: [],
            dataAtendimento: this.$moment().toDate(),
            dataRTR: new Date(),
            motivos: [],
            motivosLoading: false,
            clientes: [],
            clienteSelecionado: null,
            clientesLoading: false,
            propriedades: [],
            propriedadesLoading: false,
            currentPropriedadeUuid: null,
            currentAreaUuid: null,
            file: null,
            obsFoto: '',
            fileRtr: null,
            obsFotoRtr: '',
            fotos: [],
            fotosLoading: false,
            fotosRtr: [],
            fotosRtrLoading: false,
            areas: [],
            areasLoading: false,
            talhoes: [],
            talhoesLoading: false,
            assuntos: [],
            assuntosLoading: false,
            tipos: [],
            tiposLoading: false,
            culturas: [],
            culturasLoading: false,
            cultivares: [],
            cultivaresLoading: false,
            fases: [],
            fase: null,
            fasesLoading: false,
            /********************************* CONTROLE ******************************************/
            situacao: 0,
            situacaoRtr: 0,
            hasPropriedade: this.hasModulo('PROPRIEDADE'),
            detalhe: {},
            abas: ['geral', 'fotos', 'rtr', 'fotos-agro-visita'],
            abaSelecionada: 0,
            isSaving: false,
            isUploading: false,
            usuario: null,
            isUploadingRtr: false,
            isGenerating: false,
            saved: false,
            savedRtr: false,
            alwaysTrue: true,
            dataFocusedOut: true,
            dataInvalid: false,
            fotosPag: {
                column: 'datahora',
                order: 'desc',
                currentPage: 1,
                size: 20,
                totalRows: 0,
            },
            fotosPagRtr: {
                column: 'datahora',
                order: 'desc',
                currentPage: 1,
                size: 20,
                totalRows: 0,
            },
            fieldsFoto: [
                {
                    key: 'caminho',
                    label: 'arquivo',
                    sortable: false,
                    centered: true,
                },
                {
                    key: 'observacao',
                    label: 'observacao',
                    sortable: true,
                    width: '70%',
                },
                {
                    key: 'datahora',
                    label: 'data-hora',
                    sortable: true,
                    width: 200,
                    centered: true,
                },
                {
                    key: 'download',
                    label: 'download-arquivo',
                    sortable: false,
                    width: 50,
                    centered: true,
                },
            ],
            motivo: {
                obrigaContato: false,
                obrigaObservacao: false,
                minimoFotos: 0,
                habilitaRtr: false,
                obrigaRtr: false,
            },
            isUpdate: false,
            
            disabledByEmpresa: true,
            disabledByCliente: true,
            empresasLoading: false,
            isShowModalFotos: false,
            carousels: [],
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }
        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'venda-atendimentos-agricola');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos-agricola' },
            });
        } else {
            this.getModuloPda();
            this.carregarEmpresas('');

            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id, true);
                this.carregarAnexos();
                this.carregaExportacaoTipo();
            }
            this.getUsuario();
        }
    },
    computed: {
        habilitaAbasRTR() {
            /* Se existir motivo, pega HABILITARTR do motivo; Caso contrário, default true */
            let from_motivo = this.motivo ? this.motivo.habilitaRtr : true;

            /* Se existir o atendimento, vÃª se existe o RTR no atendimento; Caso contrário, default false */
            let from_rtr = this.atendimentoagricola ? !!this.atendimentoagricola.rtr : false;

            /* Habilitará as abas somente se o HABILITARTR do motivo permitir e se o RTR tiver sido gerado */
            return from_motivo && from_rtr;
        },
    },
    methods: {
        openModalFotos(caminho, observacao) {
            this.carousels = [];
            const images =
                this.abas[this.abaSelecionada] == 'fotos-agro-visita' ? this.fotosRtr : this.fotos;

            // Filter out the selected photo from the array of photos
            const filteredFotos = images.filter((foto) => foto.caminho !== caminho);

            // Create a new array for the carousel, combining the selected photo and the rest of the photos
            this.carousels = [
                { url: caminho, nome: observacao },
                ...filteredFotos.map((foto) => ({ url: foto.caminho, nome: foto.observacao })),
            ];

            this.isShowModalFotos = true;
        },
        verify(obj) {
            let existObjct = false;
            if (!obj) {
                existObjct = true;
            }
            return existObjct;
        },
        getModuloPda() {
            if (this.$store.state.modulopda.disponivel && this.hasModulo('ATENDIMENTOAGRICOLA')) {
                let modulo = this.getModulo('ATENDIMENTOAGRICOLA');

                /*  Isso cria o objeto para fazer com que os MODULOPDADETALHE sejam
                possÃ­veis de serem acessados diretamente.
                Ex: this.detalhe.MOTIVOATENDIMENTO.maxlength */
                modulo.detalhe.forEach((d) => {
                    this.$set(this.detalhe, d.campo, d);
                });

                this.detalhe.length = modulo.detalhe.length;
            }
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[ATENDIMENTO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[ATENDIMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.empresas = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[ATENDIMENTO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    if (this.empresas.length > 0) {
                        this.mostraFiltroEmpresa = true;
                    }
                    this.empresasLoading = false;
                });
        },
        /* Checagem do OBRIGAINCLUSAO do MODULOPDADETALHE */
        checkInvalid(campo, input) {
            let obrigainclusao;

            if (this.detalhe[campo]) {
                obrigainclusao = !!this.detalhe[campo].obrigainclusao;
            } else {
                /*  Se não existir MODULOPDADETALHE, fazer verificação manual.
                Os campos no switch-case são NOT NULL no banco, então obrigá-los sempre */
                switch (campo) {
                    case 'DATAHORA':
                    case 'DATAATENDIMENTO':
                    case 'MOTIVOATENDIMENTO':
                        obrigainclusao = true;
                        break;
                    default:
                        obrigainclusao = false;
                        break;
                }
            }

            if (obrigainclusao) {
                if (typeof input == 'string') {
                    return !input.trim();
                } else {
                    return !input;
                }
            } else {
                return false;
            }
        },
        showMessage({ type, message }) {
            this.$root.showMessage(type, message);
        },
        navigateTab(name) {
            let rtr_tabs = ['rtr', 'fotos-agro-visita'];

            if ((this.habilitaAbasRTR && rtr_tabs.includes(name)) || !rtr_tabs.includes(name)) {
                let idx = this.abas.findIndex((e) => e == name);

                if (idx > -1) {
                    this.navigateToIndex(idx);
                }
            }
        },

        // Carrega os tipos de exportaçÃµes disponiveis para essa tela
        carregaExportacaoTipo() {
            // Inidica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela(this.nomeTela).then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        navigateToIndex(idx) {
            if (
                idx > -1 &&
                !this.isUploading &&
                !this.isUploadingRtr &&
                idx != this.abaSelecionada
            ) {
                this.abaSelecionada = idx;
                window.location.hash = `#${this.abas[this.abaSelecionada]}`;

                if (this.abas[this.abaSelecionada] == 'rtr') {
                    this.carregarAssuntos();
                    this.carregarTipos();
                } else if (this.abas[this.abaSelecionada] == 'fotos-agro-visita') {
                    this.carregarAnexosRtr();
                }
            }
        },
        carregarDados(id, navigateToTab = false) {
            this.$store.commit('addLoader');

            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.atendimentoagricola = body.content;
                        this.clienteSelecionado = this.atendimentoagricola.cliente;

                        this.motivo = this.atendimentoagricola.motivoAtendimento
                            ? this.atendimentoagricola.motivoAtendimento
                            : this.motivo;
                        this.situacao = this.atendimentoagricola.situacao;
                        this.dataAtendimento = this.$moment(
                            this.atendimentoagricola.dataAtendimento,
                            'YYYY-MM-DD'
                        ).toDate();

                        if (this.atendimentoagricola.propriedade) {
                            this.currentPropriedadeUuid = this.atendimentoagricola.propriedade.uuid;
                            this.carregarPropriedades('');
                        }

                        if (this.atendimentoagricola.rtr) {
                            this.dataRTR = this.$moment(
                                this.atendimentoagricola.rtr.datahora
                            ).toDate();
                            this.situacaoRtr = this.atendimentoagricola.rtr.situacao;

                            if (this.atendimentoagricola.rtr.area && this.situacaoRtr == 0) {
                                this.currentAreaUuid = this.atendimentoagricola.rtr.area.uuid;
                                this.carregarAreas('');
                            }

                            // @87166 tratamento dos registros antigos que usavam faseCultivo
                            const isOld =
                                this.atendimentoagricola.rtr.faseFenologica == null &&
                                this.situacaoRtr > 0;
                            this.fase = isOld
                                ? this.atendimentoagricola.rtr.fasecultivo
                                : this.atendimentoagricola.rtr.faseFenologica;
                        }
                    } else {
                        this.$router.push({
                            name: 'new-venda-atendimento-agricola',
                        });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar atendimento agrícola.', e);
                })
                .finally((_) => {
                    this.carregarClientes();
                    this.$store.commit('removeLoader');

                    this.disabledByEmpresa = this.atendimentoagricola.empresa == null;
                    this.disabledByCliente = this.atendimentoagricola.cliente == null;

                    if (navigateToTab && this.$route.hash) {
                        let tab = this.$route.hash.replace('#', '');
                        this.navigateTab(tab);
                    }
                });
        },
        /*  Retrow: Utilizado ao finalizar e salvar atendimento para que
        os erros da promise do save sejam retornados para a função
        saveAndFinalizaAtendimento. Ou qualquer outra coisa que precise
        dar um catch nos erros do salvamento. */
        saveAtendimento(redirect = this.redirectToList, rethrow = false) {
            this.atendimentoagricola = this.mapTosave(
                this.atendimentoagricola,
                'datahora',
                'dataAtendimento',
                'motivoAtendimento',
                'cliente',
                'propriedade',
                'rtr'
            );
            this.atendimentoagricola.cliente = this.clienteSelecionado;

            let atendimento = {
                atendimento: this.atendimentoagricola,
            };

            if (this.validation.validate(atendimento, this.$refs)) {
                if (this.atendimentoagricola.cliente == null) {
                    this.atendimentoagricola.cliente = {
                        idcliente: 0,
                    };
                }
                this.isSaving = true;
                return this.service
                    .save(this.atendimentoagricola)
                    .then((body) => {
                        let msg = 'msg-atendimento-salva';

                        if (this.atendimentoagricola.idatendimentoagricola) {
                            msg = 'msg-atendimento-edita';
                        }

                        this.atendimentoagricola = body.content;
                        this.$root.showMessage('success', msg);
                        this.saved = true;
                        redirect(2);
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar atendimento agrÃ­cola.', e);

                        if (e.body && e.body.message && e.body.message.startsWith('msg-')) {
                            this.$root.showMessage('error', e.body.message);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao');
                        }

                        if (rethrow) {
                            throw e;
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }

            return null;
        },

        saveRTR(redirect = this.redirectToList, rethrow = false) {
            this.atendimentoagricola.rtr = this.mapTosave(
                this.atendimentoagricola.rtr,
                'assunto',
                'cultura',
                'cultivar',
                'situacao',
                'area',
                'talhao',
                'tipo',
                'datahora'
            );

            // @85037 - para não dar problema no spring.
            this.atendimentoagricola.rtr.dataHoraPdf = this.$moment().format('DD/MM/YYYY');
            this.atendimentoagricola.rtr.faseFenologica = this.fase;

            // @87166 - tramite 19
            if (this.detalhe.RTR_DATA.oculta) {
                this.atendimentoagricola.rtr.datahora = this.$moment(
                    this.atendimentoagricola.datahora
                ).format('YYYY-MM-DD');
            }

            if (this.validation.validateRtr(this.atendimentoagricola.rtr, this.$refs)) {
                this.isSaving = true;

                return this.rtrService
                    .save(this.atendimentoagricola.rtr)
                    .then((r) => {
                        this.$root.showMessage('success', 'msg-agro-visita-salvo-sucesso');
                        this.savedRtr = true;
                        redirect(2);
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar RTR.', e);
                        this.$root.showMessage('error', 'msg-agro-visita-salvo-erro');

                        if (rethrow) {
                            throw e;
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            } else {
                return null;
            }
        },

        /// Cria o objeto exportação e envia o mesmo para o banco.
        saveExportacao(tipo) {
            let exportacao = {
                idexportacao: null,
                titulo:
                    'Solicitação da exportação atendimento: ' +
                    this.atendimentoagricola.idatendimentoagricola,
                processoexportado: tipo,
                situacao: 'EXPORTANDO',
                usuario: {
                    idusuarioerp: this.$store.state.user.idusuarioerp,
                },
                exportacaotipo: {
                    idexportacaotipo: this.exportacaoTipo.idexportacaotipo, //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                },
            };

            this.isSaving = true;
            return this.exportacaoService
                .save(exportacao)
                .then((r) => {
                    this.$root.showMessage('success', 'msg-exp-solicitada');
                    this.saveLog(r.content, tipo);

                    let exportacaoAtendimentos = {
                        listatendimentos: [this.atendimentoagricola],
                        exportacao: r.content,
                        usuario: this.$store.state.user,
                        exportaAtendimento: true,
                        exportaRtr: true,
                        exportaFotosAtendimento: true,
                        exportaFotosRtr: true,
                    };

                    // Chama o savelog e passa o tipo da exportação (whats, pdf, csv...)
                    // validação para saber qual service irá chamar para gerar as exportacoes
                    this.exportacaoDadosService
                        .saveAtendimentoOld(exportacaoAtendimentos, 0, tipo) // realiza a exportacao do arquivo CSV, (busca dados, gera csv, da update na tabela exportacao e gera o log)
                        .catch((e) => {
                            console.error('Erro ao salvar exportação ', tipo, e);
                            this.$root.showMessage('error', 'msg-erro-exp-gerar');

                            if (rethrow) {
                                throw e;
                            }
                        })
                        .finally((_) => {
                            this.isSaving = false;
                        });
                })
                .catch((e) => {
                    console.error('Erro ao salvar exportação.', e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');

                    if (rethrow) {
                        throw e;
                    }
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
        /// Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: null,
                acao: exportacao.titulo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error('Erro ao salvar log exportação.', e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');

                    if (rethrow) {
                        throw e;
                    }
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'venda-atendimentos-agricola',
                });
            }, time * 1000);
        },
        downloadCSV(csv) {
            var filename, link, blob, url;

            if (csv == null) return;

            blob = new Blob(['\ufeff', csv], {
                encoding: 'UTF-8',
                type: 'data:text/csv;charset=utf-8;',
            });
            url = URL.createObjectURL(blob);

            filename = 'justificativanaovenda.csv';

            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        downloadExcel(excel) {
            var filename, link, blob, url;

            if (excel == null) return;

            blob = new Blob(['\ufeff', xls], {
                encoding: 'UTF-8',
                type: 'data:text/xls;charset=utf-8;',
            });
            url = URL.createObjectURL(blob);

            filename = 'justificativanaovenda.xls';

            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        clearFields() {
            this.atendimentoagricola = {};
        },
        checkValidacoesMotivo(motivo) {
            this.atendimentoagricola.motivoAtendimento = motivo;
            this.motivo = motivo;
        },
        /*  Rotinas para receber a data formatada pelo input e transformar de volta para YYYY-MM-DD no
          objeto caso ela seja válida */
        updateDataAtendimento(data) {
            this.dataAtendimento = data;

            let m = this.$moment(data, 'L');
            this.atendimentoagricola.dataAtendimento = m._isValid ? m.format('YYYY-MM-DD') : '';
            if (this.checkInvalid('DATAATENDIMENTO', this.atendimentoagricola.dataAtendimento)) {
                this.dataInvalid = !m._isValid;
            } else {
                this.dataInvalid = false;
            }
        },
        updateDataRTR(data) {
            this.dataRTR = data;
            this.atendimentoagricola.rtr.datahora = this.$moment(data).format('YYYY-MM-DD');
        },
        /* Aba Fotos */
        carregarAnexos(page = 1) {
            this.fotosLoading = true;
            let { column, order, size } = this.fotosPag;

            this.service
                .listAttachments(this.id, column, order, page - 1, size)
                .then((r) => {
                    this.fotos = r.content;
                    this.fotosPag.totalRows = r.totalElements;
                })
                .catch((e) => {
                    console.error('Erro ao carregar fotos do atendimento.', e);
                    this.$root.showMessage('error', 'msg-erro-carregar-foto-atendimento');
                })
                .finally((_) => {
                    this.fotosLoading = false;
                });
        },
        addAnexo() {
            this.obsFoto = this.mapTosave(this.obsFoto);

            let formbody = new FormData();
            formbody.append('file', this.file);
            formbody.append('observacao', this.obsFoto);

            this.isUploading = true;

            this.service
                .uploadAttachment(this.id, formbody)
                .then((r) => {
                    this.$root.showMessage('success', 'msg-anexo-salvo-sucesso');
                    this.fotosPag.column = 'datahora';
                    this.fotosPag.order = 'desc';

                    if (this.$refs.fotosTable) {
                        this.$refs.fotosTable.currentSortColumn = {};
                    }

                    this.file = null;
                    this.$refs.filePicker.clearFile();
                    this.obsFoto = '';
                    this.carregarAnexos();
                })
                .catch((e) => {
                    console.error('Erro ao carregar anexo.', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-anexo-upload');
                })
                .finally((_) => {
                    this.isUploading = false;
                });
        },
        sortFotos(field, order) {
            this.fotosPag.column = field;
            this.fotosPag.order = order;
            this.carregarAnexos(this.fotosPag.currentPage);
        },
        /* Aba Fotos RTR */
        carregarAnexosRtr(page = 1) {
            this.fotosRtrLoading = true;

            let { column, order, size } = this.fotosPagRtr;
            let idrtr = this.atendimentoagricola.rtr.id;

            this.rtrService
                .listAttachments(idrtr, column, order, page - 1, size)
                .then((r) => {
                    this.fotosRtr = r.content;
                    this.fotosPagRtr.totalRows = r.totalElements;
                })
                .catch((e) => {
                    console.error('Erro ao carregar fotos do RTR.', e);
                    this.$root.showMessage('error', 'msg-erro-carregar-foto-agro-visita');
                })
                .finally((_) => {
                    this.fotosRtrLoading = false;
                });
        },
        addAnexoRtr() {
            this.obsFotoRtr = this.mapTosave(this.obsFotoRtr);

            let formbody = new FormData();
            formbody.append('file', this.fileRtr);
            formbody.append('observacao', this.obsFotoRtr);

            this.isUploadingRtr = true;
            let idrtr = this.atendimentoagricola.rtr.id;

            this.rtrService
                .uploadAttachment(idrtr, formbody)
                .then((r) => {
                    this.$root.showMessage('success', 'msg-anexo-salvo-sucesso');
                    this.fotosPagRtr.column = 'datahora';
                    this.fotosPagRtr.order = 'desc';

                    if (this.$refs.fotosTable) {
                        this.$refs.fotosTable.currentSortColumn = {};
                    }

                    this.fileRtr = null;
                    this.$refs.filePickerRtr.clearFile();
                    this.obsFotoRtr = '';
                    this.carregarAnexosRtr();
                })
                .catch((e) => {
                    console.error('Erro no upload do anexo do RTR.', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-anexo-upload');
                })
                .finally((_) => {
                    this.isUploadingRtr = false;
                });
        },
        sortFotosRtr(field, order) {
            this.fotosPagRtr.column = field;
            this.fotosPagRtr.order = order;
            this.carregarAnexosRtr(this.fotosPagRtr.currentPage);
        },
        carregarClientes(termo = null) {
            if (
                this.atendimentoagricola.empresa != null &&
                this.atendimentoagricola.empresa.idempresa
            ) {
                this.clientesLoading = true;
                let params = [
                    // Adicionar filtro complementar
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    'empresa',
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.atendimentoagricola.empresa.idempresa,
                ];

                this.clienteService
                    .findAllCombo(params)
                    .then((body) => {
                        this.clientes = Object.assign(body.content);
                    })
                    .catch((e) => {
                        this.clientesLoading = false;
                        console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                    })
                    .finally((_) => {
                        // retorna como completo
                        this.clientesLoading = false;
                        if (this.atendimentoagricola.cliente != null) this.carregarPropriedades();
                    });
            }
        },
        getUsuario() {
            this.usuarioWebService
                .getByIdUsuarioErp(this.$store.state.user.idusuarioerp)
                .then((r) => {
                    this.atendimentoagricola.usuario = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de usuario. Termo: [${q}]`, e);
                })
                .finally((_) => {});
        },

        carregarMotivos(q) {
            this.motivosLoading = true;

            this.motivoService
                .findAll('descricao', 'asc', 0, 20, 1, q)
                .then((r) => {
                    this.motivos = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de motivos. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.motivosLoading = false;
                });
        },
        carregarPropriedades(q) {
            if (this.clienteSelecionado && this.clienteSelecionado.idcliente > 0) {
                // Seta como nulo para obrigar o usuario a selecionar a propriedade novamente apos trocar o cliente
                // A função carregarPropriedades ta sendo chamada pelo input do cliente
                this.propriedadesLoading = true;
                this.proprService
                    .listAllByIdCliente(this.clienteSelecionado.idcliente, 50, 0, q)
                    .then((r) => {
                        this.propriedades = r.content;
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa de propriedades. Termo: [${q}]`, e);
                    })
                    .finally((_) => {
                        this.propriedadesLoading = false;
                    });
            }
        },
        changePropriedade(p) {
            this.currentPropriedadeUuid = p.uuid;

            if (this.habilitaAbasRTR) {
                this.carregarAreas('');

                if (this.atendimentoagricola && this.atendimentoagricola.rtr) {
                    this.atendimentoagricola.rtr.area = null;
                    this.atendimentoagricola.rtr.talhao = null;
                }
            }
        },
        changeArea(a) {
            this.currentAreaUuid = a.uuid;

            if (this.habilitaAbasRTR) {
                this.carregarTalhoes('');

                if (this.atendimentoagricola && this.atendimentoagricola.rtr) {
                    this.atendimentoagricola.rtr.talhao = null;
                }
            }
        },
        carregarAssuntos() {
            this.assuntosLoading = true;
            this.assuntoService
                .findAll('descricao', 'asc', 0, 20)
                .then((r) => {
                    this.assuntos = r.content.map((e) => {
                        return {
                            idassuntortr: e.idassuntortr,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de assuntos RTR. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.assuntosLoading = false;
                });
        },
        carregarTipos(q) {
            this.tiposLoading = true;

            this.tipoService
                .findAll('descricao', 'asc', 0, 20, 2, 'ven', q)
                .then((r) => {
                    this.tipos = r.content.map((e) => {
                        return {
                            idtiportr: e.idtiportr,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de tipos de RTR. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.tiposLoading = false;
                });
        },
        carregarCulturas(q) {
            this.culturasLoading = true;

            this.culturaService
                .findAllCombo(q)
                .then((r) => {
                    if (r.content != null) {
                        this.culturas = r.content.map((e) => {
                            return {
                                idtipocultura: e.idtipocultura,
                                descricao: e.descricao,
                                id: e.id,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de cultura. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.culturasLoading = false;
                    if (this.isUpdate) {
                        this.carregarCultivares('');
                        this.carregarFases('');
                    }
                });
        },
        updateCultura(cultura) {
            this.atendimentoagricola.rtr.cultura = cultura;
            this.atendimentoagricola.rtr.cultivar = null;
            this.fase = null;
            this.carregarCultivares('');
            this.carregarFases('');
        },
        carregarCultivares(params = '') {
            if (this.atendimentoagricola.rtr.cultura != null) {
                this.cultivaresLoading = true;
                const idCultura = this.atendimentoagricola.rtr.cultura.id;

                this.cultivarService
                    .findAllComboByIdCultura(1, idCultura, params)
                    .then((r) => {
                        if (r.content != null) {
                            this.cultivares = r.content.map((e) => {
                                return {
                                    idcultivar: e.idcultivar,
                                    descricao: e.descricao,
                                    id: e.id,
                                };
                            });
                        }
                    })
                    .catch((e) => {
                        console.error(
                            `Erro ao realizar pesquisa de cultivar. Termo: [${params}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        if (this.cultivares.length > 0 && !this.isUpdate) {
                            this.atendimentoagricola.rtr.cultivar = this.cultivares[0];
                        }
                        this.cultivaresLoading = false;
                    });
            }
        },
        carregarFases(params = '') {
            if (this.atendimentoagricola.rtr.cultura != null) {
                this.fasesLoading = true;
                const idCultura = this.atendimentoagricola.rtr.cultura.id;

                this.faseService
                    .findAllComboByIdCultura(idCultura, params)
                    .then((r) => {
                        this.fases = r.content.map((e) => {
                            return {
                                idagrofasefenologica: e.agroFaseFenologica.idagrofasefenologica,
                                descricao: e.agroFaseFenologica.descricao,
                                id: e.agroFaseFenologica.id,
                            };
                        });
                    })
                    .catch((e) => {
                        console.error(
                            `Erro ao realizar pesquisa de fase fenologica. Termo: [${params}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        if (this.fases.length > 0 && !this.isUpdate) {
                            this.fase = this.fases[0];
                        }
                        this.fasesLoading = false;
                    });
            }
        },
        carregarAreas(q) {
            if (this.currentPropriedadeUuid) {
                this.areasLoading = true;

                this.areaService
                    .findAllByPropriedade(this.currentPropriedadeUuid, 20, q)
                    .then((r) => {
                        this.areas = r.content.map((e) => {
                            return {
                                idarea: e.idarea,
                                descricao: e.descricao,
                                id: e.id,
                                uuid: e.uuid,
                            };
                        });
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa de áreas. Termo: [${q}]`, e);
                    })
                    .finally((_) => {
                        this.areasLoading = false;
                    });
            }
        },
        carregarTalhoes(q) {
            if (this.currentAreaUuid) {
                this.talhoesLoading = true;

                this.talhaoService
                    .findAllByArea(this.currentAreaUuid, 20, q)
                    .then((r) => {
                        this.talhoes = r.content.map((e) => {
                            return {
                                idtalhao: e.idtalhao,
                                descricao: e.descricao,
                                id: e.id,
                                uuid: e.uuid,
                            };
                        });
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa de áreas. Termo: [${q}]`, e);
                    })
                    .finally((_) => {
                        this.talhoesLoading = false;
                    });
            }
        },
        /* RTR */
        promptForRTR() {
            this.$root.confirm({
                message: this.$t('msg-confirm-generate-agro-visita'),
                onConfirm: this.generateRtr,
            });
        },
        generateRtr() {
            this.isGenerating = true;

            this.rtrService
                .generateRtrToAtendimento(this.id)
                .then((r) => {
                    this.$root.showMessage('success', 'msg-agro-visita-gerado-sucesso');
                    this.carregarDados(this.id);
                    this.carregarAnexos();
                })
                .catch((e) => {
                    console.error('Erro ao gerar RTR.', e);
                    this.$root.showMessage('error', 'msg-agro-visita-gerado-erro');
                })
                .finally((_) => {
                    this.isGenerating = false;
                });
        },
        /* Finalização do Atendimento */
        promptFinalize() {
            let model = {
                atendimento: this.atendimentoagricola,
                fotos: this.fotos,
            };

            if (this.validation.validate(model, this.$refs, true)) {
                this.$root.confirm({
                    message: this.$t('msg-finalizar-atendimento'),
                    onConfirm: this.saveAndFinalizeAtendimento,
                });
            } else if (model.atendimento.motivoAtendimento.minimoFotos > model.fotos.length) {
                this.navigateToIndex(1);
            }
        },
        saveAndFinalizeAtendimento() {
            this.isSaving = true;

            let promiseAtd = this.saveAtendimento((_) => {}, true);

            if (promiseAtd) {
                promiseAtd
                    .then((r) => {
                        this.isSaving = true;

                        this.service
                            .finalize(this.id)
                            .then((r) => {
                                this.$root.showMessage(
                                    'success',
                                    'msg-sucesso-finalizar-atendimento'
                                );
                                this.redirectToList(2);
                            })
                            .catch((e) => {
                                console.error('Erro ao finalizar atendimento.', e);
                                if (e.body.message) {
                                    this.$root.showMessage('error', e.body.message);
                                } else {
                                    this.$root.showMessage(
                                        'error',
                                        'msg-erro-finalizar-atendimento'
                                    );
                                }
                                this.isSaving = false;
                            })
                            .finally((_) => {
                                this.isSaving = false;
                            });
                    })
                    .catch((e) => {
                        console.warn('Atendimento não finalizado por erro ao salvar atendimento.');
                        this.isSaving = false;
                    });
            } else {
                console.warn('Atendimento não finalizado por erro ao salvar atendimento.');
                this.isSaving = false;
            }
        },
        /* Finalização do RTR */
        promptFinalizeRtr() {
            if (this.validation.validateRtr(this.atendimentoagricola.rtr, this.$refs)) {
                this.$root.confirm({
                    message: this.$t('msg-finalizar-agro-visita'),
                    onConfirm: this.saveAndFinalizeRtr,
                });
            }
        },
        saveAndFinalizeRtr() {
            this.isSaving = true;

            let promiseRtr = this.saveRTR((_) => {}, true);

            if (promiseRtr) {
                promiseRtr
                    .then((r) => {
                        this.isSaving = true;

                        this.rtrService
                            .finalize(this.atendimentoagricola.rtr.id)
                            .then((r) => {
                                this.$root.showMessage(
                                    'success',
                                    'msg-sucesso-finalizar-agro-visita'
                                );
                                this.redirectToList(2);
                            })
                            .catch((e) => {
                                console.error('Erro ao finalizar RTR.', e);
                                this.$root.showMessage('error', 'msg-erro-finalizar-agro-visita');
                            })
                            .finally((_) => {
                                this.isSaving = false;
                            });
                    })
                    .catch((e) => {
                        console.warn('Atendimento não finalizado por erro ao salvar RTR.');
                    });
            }
        },

        /// METODOS QUE REALIZAR A LIMPEZA DOS CAMPOS CASO O USUARIO TROQUE A EMPRESA OU O CLIENTE
        updateValueEmpresa(val) {
            this.atendimentoagricola.propriedade = null;
            this.atendimentoagricola.cliente = null;
            this.clienteSelecionado = null;
            this.propriedades = [];
            this.carregarClientes();
            this.disabledByEmpresa = val == null;
        },
        updateValueCliente(val) {
            this.clienteSelecionado = val;
            this.atendimentoagricola.propriedade = null;
            this.carregarPropriedades();
            this.disabledByCliente = val == null;
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';

.columns:last-child {
    padding-top: 0.2rem !important;
}

#main {
    padding: 0 20px 20px 20px;
    min-height: 100%;

    .page {
        position: relative;
        //   padding: 0 20px;
        //   background-color: $sovis-white;
        //   box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        //   border-radius: 2px;
        //   height: inherit;
        //   min-height: 100%;

        .nav.nav-tabs {
            margin-bottom: 20px;
            margin-left: -20px;
            padding-left: 20px;
        }

        h1 {
            padding-top: 20px;
            margin-bottom: 40px;

            &.title {
                margin-right: 550px;
            }
        }

        .aba-geral,
        .aba-fotos,
        .aba-agro-visita {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }

        .aba-fotos {
            .fotos-loader {
                margin-top: -1rem;
            }
        }

        .vertical-flow {
            position: relative;
        }

        .exportIcons {
            display: flex;
            justify-content: flex-end;
            padding-top: 10px;
        }

        .export-icon {
            color: var(--primary-color);
            padding-right: 1rem;
        }

        .obs {
            display: flex;
            margin-bottom: 20px;
            flex-direction: column;
            flex-grow: 1;

            .obs-ta {
                flex-grow: 1;
                min-height: 250px;
            }
        }

        .upload-picker {
            font-size: 12px;
        }

        .img-table {
            max-height: 10vh;
            max-width: 10vw;
        }

        .photo-warning {
            display: flex;
            justify-content: center;
            color: $red-alert;
            font-weight: bold;
        }
    }

    .form-buttons {
        right: 0;
    }
}
.hero-body-img {
    padding: 20px;
}
.icons {
    margin-bottom: 20px;
    margin-left: -20px;
    padding-left: 20px;
}
@media only screen and (max-width: 760px) {
    .form-buttons {
        clear: both;
    }
    .column {
        padding-bottom: 0;
    }
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
    .column {
        @include default-size-column;
    }
}
</style>
